import React from 'react'
import {Link} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import moment from "moment";
import DatePicker from "react-datepicker";

class DetailFeesManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: null,
            endDate: null,
            discountValue: 0,
            discountType: 1,
            name: "",
            des: "",
            status: "",
            serviceList: []
        };
    }

    componentWillMount() {
    }

    onCreate = () => {
        let {discountValue, discountType, endDate, startDate, name, des, status, numberOfInvoicesConstraintId, numberOfEmployeesConstraintId, numberOfDocumentsConstraintId, numberOfMonths, serviceList} = this.state;
        if (name == "" || name.length < 6){
            toast.error("Tên chương trình phải lớn hơn 6 ký tự");
        }else if (des == "" || des.length < 6){
            toast.error("Mô tả chương trình phải lớn hơn 6 ký tự");
        }else if (discountValue == "" || discountValue < 0){
            toast.error("Giá trị giảm phải lớn hơn hoặc bằng 0");
        }else if (startDate == null || endDate == null){
            toast.error("Vui lòng chọn ngày bắt đầu và kết thúc chương trình");
        }else if (startDate > endDate){
            toast.error("Ngày kết thúc phải lớn hơn ngày bắt đầu");
        }else if (serviceList.length < 1){
            toast.error("Vui lòng chọn dịch vụ!");
        }else {
            let listData = serviceList.map((data) => ({"servicePlanId": data.id, "servicePlanName": data.servicePlanName, "servicePlanType": data.type, "programId": 0}));
            let payload = {
                name: name,
                des: des,
                discountValue: discountValue,
                discountType: discountType,
                startDate: startDate,
                endDate: endDate,
                numberOfInvoicesConstraintId: numberOfInvoicesConstraintId,
                numberOfEmployeesConstraintId: numberOfEmployeesConstraintId,
                numberOfDocumentsConstraintId: numberOfDocumentsConstraintId,
                numberOfMonths: numberOfMonths,
                createProgramServiceList: listData,
            }
            // AdminProgramManager.create(payload, res => {
            //     if (res.success){
            //         this.props.history.push("/ad-sas-school/program-management")
            //         toast.success("Tạo chương trình thành công!")
            //     } else {
            //         toast.error("Đã xảy ra lỗi! " + res.message)
            //     }
            // })
        }
    }
    render() {
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="student-info-management" parentClass="student-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Thông tin học sinh"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>CHI TIẾT HỌC SINH</h2>
                                        <div className="row">
                                            <div className="col-12 d-flex mb-2 bg-top-title">
                                                THÔNG TIN CHUNG
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Khối</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.discountType}
                                                    onChange={(e) => {
                                                        this.state.discountType = e.target.value;
                                                        this.setState({
                                                            discountType: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="1">Khối 1</option>
                                                    <option value="2">Khối 2</option>
                                                </select>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Lớp</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.discountType}
                                                    onChange={(e) => {
                                                        this.state.discountType = e.target.value;
                                                        this.setState({
                                                            discountType: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="1">Lớp 1A</option>
                                                    <option value="2">Lớp 1B</option>
                                                    <option value="2">Lớp 1C</option>
                                                </select>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.discountType}
                                                    onChange={(e) => {
                                                        this.state.discountType = e.target.value;
                                                        this.setState({
                                                            discountType: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="1">Đang học</option>
                                                    <option value="2">Tốt nghiệp</option>
                                                    <option value="2">Thôi học</option>
                                                </select>
                                            </div>

                                            <div className="col-6 d-flex mb-2">
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số đăng hộ</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Mã học sinh</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Họ và tên</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày sinh</label>
                                                <DatePicker
                                                    className="w-auto2 react-datepicker-wrapper2 react-datepicker__input-container form-control shadow-none"
                                                    placeholderText="Ngày sinh"
                                                    selected={this.state.startDate === null ? "" : new Date(this.state.startDate)}
                                                    minDate={new Date()}
                                                    dateFormat="dd-MM-yyyy"
                                                    isClearable={this.state.startDate === null ? false : true}
                                                    selectsStart
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            this.setState({
                                                                startDate: date === null ? null : moment(date).format("YYYY-MM-DD"),
                                                            })
                                                        }
                                                    }
                                                    startDate={new Date()}
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Giới tính</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.discountType}
                                                    onChange={(e) => {
                                                        this.state.discountType = e.target.value;
                                                        this.setState({
                                                            discountType: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="1">Nam</option>
                                                    <option value="2">Nữ</option>
                                                </select>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                            </div>

                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tỉnh thành</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.discountType}
                                                    onChange={(e) => {
                                                        this.state.discountType = e.target.value;
                                                        this.setState({
                                                            discountType: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="1">Chọn tỉnh</option>
                                                    <option value="2">Hà Nội</option>
                                                </select>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Quận huyện</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.discountType}
                                                    onChange={(e) => {
                                                        this.state.discountType = e.target.value;
                                                        this.setState({
                                                            discountType: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="1">Chọn huyện</option>
                                                    <option value="2">Thanh Xuân</option>
                                                </select>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Xã phường</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.discountType}
                                                    onChange={(e) => {
                                                        this.state.discountType = e.target.value;
                                                        this.setState({
                                                            discountType: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="1">Chọn xã/phường</option>
                                                    <option value="2">Xã nào đó</option>
                                                </select>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Địa chỉ</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày vào trường</label>
                                                <DatePicker
                                                    className="w-auto2 react-datepicker-wrapper2 react-datepicker__input-container form-control shadow-none"
                                                    placeholderText="Ngày vào trường"
                                                    selected={this.state.startDate === null ? "" : new Date(this.state.startDate)}
                                                    minDate={new Date()}
                                                    dateFormat="dd-MM-yyyy"
                                                    isClearable={this.state.startDate === null ? false : true}
                                                    selectsStart
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            this.setState({
                                                                startDate: date === null ? null : moment(date).format("YYYY-MM-DD"),
                                                            })
                                                        }
                                                    }
                                                    startDate={new Date()}
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Hình thức</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.discountType}
                                                    onChange={(e) => {
                                                        this.state.discountType = e.target.value;
                                                        this.setState({
                                                            discountType: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="1">Lựa chọn</option>
                                                    <option value="2">Xã nào đó</option>
                                                </select>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Nơi sinh</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Quê quán</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Địa chỉ thường trú</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Địa chỉ tạm chú</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 d-flex mb-2 bg-top-title">
                                                THÔNG TIN CÁ NHÂN
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Dân tộc</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.discountType}
                                                    onChange={(e) => {
                                                        this.state.discountType = e.target.value;
                                                        this.setState({
                                                            discountType: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="1">Chọn dân tộc</option>
                                                    <option value="2">Kinh</option>
                                                </select>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tôn giáo</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.discountType}
                                                    onChange={(e) => {
                                                        this.state.discountType = e.target.value;
                                                        this.setState({
                                                            discountType: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="1">Chọn</option>
                                                    <option value="2">Có</option>
                                                    <option value="3">Không</option>
                                                </select>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Đối tượng ưu tiên</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.discountType}
                                                    onChange={(e) => {
                                                        this.state.discountType = e.target.value;
                                                        this.setState({
                                                            discountType: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="1">Chọn</option>
                                                    <option value="2">Có</option>
                                                    <option value="3">Không</option>
                                                </select>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Đối tượng chính sách</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.discountType}
                                                    onChange={(e) => {
                                                        this.state.discountType = e.target.value;
                                                        this.setState({
                                                            discountType: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="1">Chọn</option>
                                                    <option value="2">Con thương binh</option>
                                                    <option value="3">Con bệnh binh</option>
                                                    <option value="3">Con liệt sỹ</option>
                                                </select>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số điện thoại</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Email</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 d-flex mb-2 bg-top-title">
                                                THÔNG TIN GIA ĐÌNH
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Thành phần gia đình</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.discountType}
                                                    onChange={(e) => {
                                                        this.state.discountType = e.target.value;
                                                        this.setState({
                                                            discountType: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="1">Chọn dân tộc</option>
                                                    <option value="2">Kinh</option>
                                                </select>
                                            </div>

                                            <div className="col-5 d-flex mb-2">
                                                <div className="checkbox clearfix mr-5">
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) => {
                                                                const value = this.state.nationalFather;
                                                                this.setState({nationalFather: !value});
                                                            }}
                                                            checked={this.state.nationalFather}
                                                        />
                                                        {' '}
                                                        Có bố là dân tộc
                                                    </label>
                                                </div>
                                                <div className="checkbox clearfix">
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) => {
                                                                const value = this.state.nationalMother;
                                                                this.setState({nationalMother: !value});
                                                            }}
                                                            checked={this.state.nationalMother}
                                                        />
                                                        {' '}
                                                        Có mẹ là dân tộc
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col-12 d-flex mb-2 row">
                                                <label className="col-1 label-item pl-0">Họ tên cha</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none col-2 mr-1"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="Năm sinh cha"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="Nghề nghiệp cha"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="SĐT cha"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="Gmail cha"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-12 d-flex mb-2 row">
                                                <label className="col-1 label-item pl-0">Họ tên mẹ</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none col-2 mr-1"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="Năm sinh mẹ"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="Nghề nghiệp mẹ"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="SĐT mẹ"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="Gmail mẹ"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-12 d-flex mb-2 row">
                                                <label className="col-1 label-item pl-0">Họ tên người bảo hộ</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none col-2 mr-1"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="Năm sinh NBH"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="Nghề nghiệp NBH"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="SĐT NBH"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                                <input
                                                    placeholder="Gmail NBH"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none  col-2 mr-1"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                            disabled={this.state.serviceList.length < 1 || this.state.name == "" || this.state.des == "" || this.state.startDate == null || this.state.endDate == null}
                                            onClick={()=> {
                                                this.onCreate()
                                            }}
                                        >
                                            Chuyển lớp
                                        </button>
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/program-management"
                                                }}
                                            >
                                                Chuyển trường
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default DetailFeesManagement
